import { useTranslation } from 'react-i18next';
import {
    Banner,
    BannerDescription,
    BannerEyebrow,
    BannerImage,
    BannerImageContainer,
    BannerLinks,
    BannerText,
    BannerTextContainer,
    BannerTitle,
    BoundedContent,
    Button,
    Column,
    FluidImage,
    GridContainer,
    Link,
    Row,
} from '@vp/swan';
import { sanitiseLocale } from '../../../../i18n/config';
import { useTrackNavigationClicked } from '../../../../utils/analytics';
import { logomakerCtaPathByLocale } from '../../../../utils/urls';

const FeatureBannerMoreForFree = () => {
    const { t, i18n } = useTranslation();
    const locale = sanitiseLocale(i18n.language);

    const ctaRef = useTrackNavigationClicked(
        'Design Services',
        'Feature Banner More For Free CTA',
        logomakerCtaPathByLocale(locale),
        'logoMaker',
    );

    return (
        <BoundedContent
            as="section"
            id="more-for-free"
            py={{ xs: 4, md: 8 }}
            paddingBottom={{ xs: 8, md: 11 }}
            paddingX={{ xs: 0, sm: 3, md: 4, lg: 4, xl: 4 }}
        >
            <GridContainer>
                <Row style={{ justifyContent: 'center' }}>
                    <Column span={12} spanXl={10} spanLg={11} paddingX={{ xs: 0 }}>
                        <Banner backgroundColor="standard">
                            <BannerTextContainer>
                                <BannerText textAlign={'left'}>
                                    <BannerEyebrow>
                                        {t(
                                            'Logomaker GenAi Landing Page > Feature Banner More For Free > Eyebrow.value',
                                        )}
                                    </BannerEyebrow>
                                    <BannerTitle as="h2" fontSkin="title-section">
                                        {t(
                                            'Logomaker GenAi Landing Page > Feature Banner More For Free > Title.value',
                                        )}
                                    </BannerTitle>
                                    <BannerDescription as="p">
                                        {t(
                                            'Logomaker GenAi Landing Page > Feature Banner More For Free > Description.value',
                                        )}
                                    </BannerDescription>
                                    <BannerLinks display={{ xs: 'none', sm: 'flex' }}>
                                        <Button
                                            skin="primary"
                                            render={(props) => (
                                                <Link
                                                    to={logomakerCtaPathByLocale(locale)}
                                                    className={props.className}
                                                    ref={ctaRef}
                                                >
                                                    {props.children}
                                                </Link>
                                            )}
                                        >
                                            {t(
                                                'Logomaker GenAi Landing Page > Feature Banner More For Free > CTA Text.value',
                                            )}
                                        </Button>
                                    </BannerLinks>
                                </BannerText>
                            </BannerTextContainer>
                            <BannerImageContainer>
                                <BannerImage>
                                    <FluidImage
                                        src={t(
                                            'Logomaker GenAi Landing Page > Feature Banner More For Free > Image.src',
                                        )}
                                        alt={t(
                                            'Logomaker GenAi Landing Page > Feature Banner More For Free > Image > Alt Text.value',
                                        )}
                                    />
                                </BannerImage>
                            </BannerImageContainer>
                        </Banner>
                    </Column>
                </Row>
            </GridContainer>
        </BoundedContent>
    );
};

export default FeatureBannerMoreForFree;
